module.exports = __webpack_public_path__ + "img/collection-engagementRingsTensionRing.4e66cb8.jpg";